module.exports = __webpack_public_path__ + "img/a7.cae38470.svg";